export enum ScheduleBoardFilterType {
	ASSIGNED = -1,
	UNASSIGNED = -2
}
